
import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { SITE_TITLE, INDEX_URL, ucwords } from '../../settings/common';
import { seo } from '../../settings/seo';
import { Validation } from '../../helpers/validation';
import { encrypt } from '../../helpers/encryption';
import WAServices from '../../services/WAServices';
import { AppContext } from '../../helpers/AppContext';
import { Overlay } from '../../helpers/Overlay';
import { showSuccessMessage, showErrorMessage } from '../../helpers/flash-messages';


const SignUpPage = () => {
    const [formData, setFormData] = useState({});
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [sendOtp, setSendOtp] = useState(false);
    const [otp, setOtp] = useState(new Array(6).fill(''));
    const { setSharedAuthUser } = useContext(AppContext);
    const navigate = useNavigate();
    const waServices = new WAServices();
    useEffect(() => {
        seo({
            title: SITE_TITLE + ' || Sign Up',
            metaDescription: '',
        });
    },[]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        const newFormData = {
            ...formData,
            [name]: value,
        };
        setFormData(newFormData);
    };

    // Handle OTP input change
    const handleOtpChange = (e, index) => {
        const { value } = e.target;
        const newOtp = [...otp];

        if (/^\d$/.test(value)) {  // Only allow a single digit
            newOtp[index] = value;
            setOtp(newOtp);
            if (index < 5) {
                document.getElementById(`otp-input-${index + 1}`).focus(); // Move to next input
            }
        } else if (value === '') {
            newOtp[index] = ''; // Clear the field on backspace
            setOtp(newOtp);
        }
        if(newOtp.length === 6) {
        	formData['otp'] = newOtp.join('');
        } else {
        	formData['otp'] = '';
        }
        console.log(formData);
    };

    const handleOtpKeyDown = (e, index) => {
        if (e.key === 'Backspace' && index > 0 && otp[index] === '') {
            document.getElementById(`otp-input-${index - 1}`).focus(); // Move to previous input on backspace
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const errors = (sendOtp) ? Validation(formData,['otp']) : Validation(formData,['first_name','last_name','business_phone_number','email','password','confirm_password']);
        if (Object.keys(errors).length > 0) {
          setErrors(errors);
          return;
        }
        submitForm();
    };

    const submitForm = async () => {
        try {
            setLoading(true);
            setErrors({});
            if(!sendOtp) {
                waServices.sendOtp(formData).then(response => {
                    const data = response.data;
                    console.log(data);
                    if(data.status === 'success') {
                        if(data.data.is_send) {
                            showSuccessMessage(`${data.message}`);
                            setSendOtp(true);
                        } else {
                            showErrorMessage(`${data.message}`);
                        }
                    } else {
                        showErrorMessage(`${data.message}`);
                    }
                    setLoading(false);
                });
            } else {
                waServices.signup(formData).then(response => {
                    const data = response.data;
                    if(data.status === 'success') {
                        encrypt(data.data, '__bs_auth_user');
                        //localStorage.setItem('__bs_auth_user', JSON.stringify(data.data));
                        setSharedAuthUser(data.data);
                        showSuccessMessage(`${data.message}`);
                        navigate(INDEX_URL+'dashboard');
                    } else {
                        showErrorMessage(`${data.message}`)
                    }
                    setLoading(false);
                });
            }
        } catch (error) {
            setLoading(false);
            // Check for server-side error (500)
            if (error.response && error.response.status === 500) {
                showErrorMessage('Server error: Something went wrong. Please try again later.');
            } else {
                // Handle other types of errors, such as network errors
                showErrorMessage('An error occurred. Please check your connection and try again.');
            }
        }
    }

    const renderSignUpForm = () => {
        return(
            <React.Fragment>
                <form className="cx-form" onSubmit={handleSubmit}>
                    <h4>Sign Up</h4>
                    {(!sendOtp) && (
                    	<React.Fragment>
		                    <div className="input-control">
		                        <input type="text" placeholder="Enter first name" name="first_name" value={formData.first_name || ''} onChange={handleChange}/>
		                        {errors.first_name && <div className="text-danger">{errors.first_name}</div>}
		                    </div>
		                    <div className="input-control">
		                        <input type="text" placeholder="Enter last name" name="last_name" value={formData.last_name || ''} onChange={handleChange}/>
		                        {errors.last_name && <div className="text-danger">{errors.last_name}</div>}
		                    </div>
		                    <div className="input-control">
		                        <input type="text" placeholder="Enter phone numer" name="business_phone_number" value={formData.business_phone_number || ''} onChange={handleChange}/>
		                        {errors.business_phone_number && <div className="text-danger">{errors.business_phone_number}</div>}
		                    </div>
                    		<div className="input-control">
		                        <input type="text" placeholder="Enter email address" name="email" value={formData.email || ''} onChange={handleChange}/>
		                        {errors.email && <div className="text-danger">{errors.email}</div>}
		                    </div>
                            <div className="input-control">
                                <input type="password" placeholder="Enter your password" name="password" value={formData.password || ''} onChange={handleChange}/>
                                {errors.password && <div className="text-danger">{errors.password}</div>}
                            </div>
                            <div className="input-control">
                                <input type="password" placeholder="Re-enter your password" name="confirm_password" value={formData.password || ''} onChange={handleChange}/>
                                {errors.confirm_password && <div className="text-danger">{errors.confirm_password}</div>}
                            </div>
		                    <div className="form-btns">
		                        <button type="submit" disabled={loading}>{loading ? 'Processing...' : 'Signup'}</button>
		                    </div>
                    	</React.Fragment>
                    )}
                    {(sendOtp) && (
                    	<React.Fragment>
                    		<div className="otp-inputs">
                                {otp.map((digit, index) => (
                                    <input
                                        key={index}
                                        type="text"
                                        maxLength="1"
                                        id={`otp-input-${index}`}
                                        value={digit}
                                        onChange={(e) => handleOtpChange(e, index)}
                                        onKeyDown={(e) => handleOtpKeyDown(e, index)}
                                        className="otp-box"
                                    />
                                ))}
                            </div>
                            <div className="otp-inputs">
                                {errors.otp && <div className="text-danger">{errors.otp}</div>}
                            </div>
		                    <div className="form-btns">
		                        <button type="submit" disabled={loading}>{loading ? 'Processing...' : 'Send Otp'}</button>
		                    </div>
                    	</React.Fragment>
                    )}
                </form>
            </React.Fragment>
        )
    }
    return (
        <React.Fragment>
            <main className="wrapper">
                <section className="auth-section">
                    <div className="cx-left">
                        <div className="cx-bg"></div>
                    </div>
                    <div className="cx-right">
                        <div className="cx-form-page">
                            {/* <!-- Login form --> */}
                            {renderSignUpForm()}
                        </div>
                    </div>
        	    </section>
                {/* Show loading overlay when `loading` is true */}
                {loading && (
                    <Overlay />
                )}
            </main>
        </React.Fragment>
    );
};
                
export default SignUpPage;